﻿import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import AppRouter from './routes/AppRouter';
import { msalConfig } from './auth/authConfig';
import './index.css';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering
msalInstance.initialize().then(() => {
  createRoot(document.getElementById('root')).render(
    <MsalProvider instance={msalInstance}>
      <AppRouter />
    </MsalProvider>
  );
});
